import React from 'react';
import FormItemEditorRenderForAutoLookup from './FormItemEditorRenderForAutoLookup';
import FormItemTimeDisplay from '../display/FormItemTimeDisplay';
require('../../styles/FormItemRender.css');
export default class FormItemTimeRenderForAutoLookup extends FormItemEditorRenderForAutoLookup
{
	constructor(props) {
		super(props);
	}

	getDisplay(_value)
	{
		if(_value == null || _value == undefined)
			_value = this.props.value;

		_value = FormItemTimeDisplay.getDisplayText(_value,this.props.showHour,this.props.showMinute,this.props.showSecond);

		return _value;
	}

	render()
	{
		let _value = this.props.rowData[this.props.dataField];
		_value = this.getDisplay(_value);
		
		return(
			<div className="gongqi_render_select" style={{padding:'3px'}} ref={ node => this.componentLabel = node }>
				{_value}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemTimeRenderForAutoLookup.js